import type { components } from '@pba/types-openapi-client';
import type { GroupPreviewType } from './group';
import { type Image, createImage } from './image';

export type Preview = {
  data: PreviewData[];
  groupType: GroupPreviewType;
  total: number;
};

export type PreviewData = {
  coverPhoto: Image;
  id: string;
  name: string;
  usersCount: number;
};

const createPreviewData = (data: components['schemas']['PreviewData']): PreviewData => ({
  coverPhoto: createImage(data.cover_photo),
  id: data.id,
  name: data.name,
  usersCount: data.users_count,
});

export const createPreview = (data: components['schemas']['Preview']): Preview => ({
  data: data.data.map((groupPreview) => createPreviewData(groupPreview)),
  groupType: data.group_type,
  total: data.total,
});
